import { motion } from "framer-motion";
import { Instagram } from "lucide-react";
import { Eyebrow, MaskText } from "@/components/motion";
import { INSTA, INSTAGRAM } from "@/data/catalog";
import { EASE } from "@/lib/scroll";

export const InstagramGrid = () => (
  <section id="instagram" data-testid="instagram-section" className="theme-light relative bg-ink-2 text-cream">
    <div className="mx-auto max-w-[1440px] px-5 py-24 sm:px-8 lg:px-12 lg:py-36">
    <div className="mb-12 flex flex-wrap items-end justify-between gap-6">
      <div>
        <Eyebrow>10 — Spotted on Instagram</Eyebrow>
        <h2 className="mt-5 font-display text-5xl font-light leading-[0.95] text-cream sm:text-6xl lg:text-7xl">
          <MaskText lines={[<em key="e" className="italic text-champagne">@acevanity1</em>]} />
        </h2>
      </div>
      <a href={INSTAGRAM} target="_blank" rel="noreferrer" data-testid="instagram-follow-button" className="btn-gold">
        <Instagram className="h-4 w-4" /> Follow the edit
      </a>
    </div>
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4 sm:gap-3">
      {INSTA.map((src, i) => (
        <motion.a
          key={src}
          href={INSTAGRAM}
          target="_blank"
          rel="noreferrer"
          data-testid={`instagram-tile-${i}`}
          initial={{ opacity: 0, scale: 0.94 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true, amount: 0.15 }}
          transition={{ duration: 0.9, ease: EASE, delay: (i % 4) * 0.07 }}
          className={`group relative block overflow-hidden ${i % 3 === 0 ? "aspect-[4/5]" : "aspect-square"}`}
        >
          <img src={src} alt="Ace Vanity on Instagram" loading="lazy" className="absolute inset-0 h-full w-full object-cover transition-transform duration-[1200ms] group-hover:scale-110" />
          <div className="absolute inset-0 grid place-items-center bg-ink/0 transition-colors duration-500 group-hover:bg-ink/50">
            <Instagram className="h-7 w-7 scale-50 text-champagne opacity-0 transition-all duration-500 group-hover:scale-100 group-hover:opacity-100" />
          </div>
        </motion.a>
      ))}
    </div>
    </div>
  </section>
);
